export default "__VITE_ASSET__Cxl8viqD__"